import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';
import { Layout } from 'antd';
const { Content } = Layout;

class ErrorPage extends Component {
  
  render() {
    const { match:{ params:{ message = null } = {} } = {} } = this.props
    return (
      <Content className={styles.content_404}>
        <div className={styles.page404}>
          <h1>Information</h1>
          <h2>{message ? message:'頁面製作中'}</h2>
          <p></p>
        </div>
      </Content>
    );
  }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/views/SystemInfo/InfoPage.js